import { Dispatch, SetStateAction, useContext } from "react";
import apiCall from "../../utility/api";
    // import { setExecuteTroubleShooter } from 'graphql-queries/v2/troubleshoot_queries';
import ManageView from '../../components/manage_view/manageView.component';


interface troubleShootData {
    serviceTag: string
    solutionVar: string
    deviceStatus: string
    applicationname: string
    setmessagebar2: Dispatch<SetStateAction<boolean>>;
    setTroubleshootErrorMsg: Dispatch<SetStateAction<any>>;
    setToastMessage: Dispatch<SetStateAction<string>>;
    setToastIntent: Dispatch<SetStateAction<string>>;
    setPreviousJob: Dispatch<SetStateAction<any>>;
    setOverlayOpen: Dispatch<SetStateAction<boolean>>;
    previousJob: any
    tenant: string
}

interface solutionListData {
    contextValue: any
    setTroubleshooterSolutionList?: Dispatch<SetStateAction<object[] | null>> | any;

}
interface otherSolutionData {
    setViewSoultions: Dispatch<SetStateAction<object[] | null>>,
    troubleshooterSolutionList: any[], 
    tenant: string
}
export const getAlertDetails = async (data: solutionListData): Promise<void> => {
    const { contextValue, setTroubleshooterSolutionList } = data
    const name = `${contextValue.selectedRowDetails.name}`;
    try {
        const { status, data } = await apiCall('/alerts/getAlertDetails', { name })
        console.log("alert details: " + JSON.stringify(data));
        if (status === "success" && data != undefined) {
            let solutionList = JSON.parse(data.solutions);
            // props.handleEditData(data);
            const solutionOptionData = [{key1: 0, label: 'empty'}]
            solutionList.map((value, index) => {
                solutionOptionData.push({ key1: index +1 , label: value })
            })
            setTroubleshooterSolutionList(solutionOptionData);
        } else {
            // props.handleEditData(data);
        }
    } catch (error) {
        console.error("An unexpected error occurred:", (error as Error).message);
    }
};
export const getAlertJobPendingStatus = async (applicationname: string, tenant: string): Promise<boolean> => {
    // let contextValue: any = useContext(GlobalContext);
    // let tenant = contextValue.tenantName;
    try {
        let whereCondition = { applicationname, tenant }
        let { status, data } = await apiCall('/troubleshoot/getPendingJobStatus', { ...whereCondition });
        console.log('pendingjob data: ' + data)
        console.log('pendingjob status: ' + status) 
        return  data?.length > 0
    } catch (error) {
        console.error("An error occurred:", error);
    }
}    

export const otherSolutionsList = async (data: otherSolutionData):Promise<void> => {
    // Get all the solutions other than the Recommanded Soutions
    const { setViewSoultions, troubleshooterSolutionList, tenant } = data
    try {
        const whereCondition = { types: ["selfhelp", "proactive"], tenant: tenant }
        let limit = 0
        let offset = 0
        let data = await apiCall('/troubleshoot/getTroubleshootList', { ...whereCondition, limit, offset });
            if (data?.status == 'success') {
                const allSolutions = []
                data?.data?.map(async (solution, index) => {
                        allSolutions.push({ key1: index + 1, label: solution?.automationName })
                })
                const otherSolutions = allSolutions.filter((solution) => {
                    return !troubleshooterSolutionList.some((item) => item.label === solution.label)
                })
                otherSolutions.push({key1: 0, label: 'empty'})
                setViewSoultions(otherSolutions)
            }
    } catch (error) {
        console.log('getTroubleshootList error= ', error);
    }
}

export const alertTroubleShootPush = async (data: troubleShootData) => {

    const { serviceTag, solutionVar, deviceStatus, applicationname, setmessagebar2, setTroubleshootErrorMsg, setToastMessage, setToastIntent, setPreviousJob, previousJob, setOverlayOpen, tenant } = data;
    const previousJobStatus = await getAlertJobPendingStatus(applicationname, tenant);  

    if (previousJobStatus) {
        setPreviousJob(true)
    } else {
        var url = `/troubleshoot/pushSolutionItems`;
        var postData = {
            "servicetag": serviceTag,
            "solutionVar": solutionVar,
            "username": 'admin@nanoheal.com',
            "type": 'Alert',
            "applicationname": applicationname
        };
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        try {
            let { status, msg } = await apiCall(url, postData, "POST");
            if (status == "success") {
                if (deviceStatus == "online") {
                    //const troubleshootingLink = <Link to="/manage/troubleshoot/status">Troubleshooting Status</Link>;
                    // setToastmessage(`Troubleshooter Executed Successfully. Please check ${troubleshootingLink} for detailed information on the execution status`)
                    setToastMessage("Troubleshooter Executed Successfully")
                } else if (deviceStatus == "offline") {
                    setToastMessage("Troubleshooter Pushed Successfully");
                }
                setOverlayOpen(false)
                setmessagebar2(true);
                //props.setExecuteBtnClicked(false);
            } else {
                setOverlayOpen(false)
                setToastMessage("Troubleshooter Pushed Failed!");
                setTroubleshootErrorMsg(true)
                setToastIntent('error')
            }

        } catch (error) {
            setOverlayOpen(false)
            setTroubleshootErrorMsg(true)
            setToastMessage("Troubleshooter Pushed Failed!");
            setToastIntent('error')
            console.log("Alert TroubleshooterPush error=", error)
        }
    }

}